import React from 'react';
import { Helmet } from 'react-helmet-async';
import Button from './Button';
import ServiceShowcase from './ServiceShowcase';
import { BRAND, brandify } from '../brandConfig';

const AutomationPage = ({ navigate }) => {
  return (
    <div className="py-32 max-w-[95vw] mx-auto px-4 md:px-8 bg-background min-h-screen flex flex-col justify-between">
      <Helmet>
        <title>{`Marketing Automation Services | ${BRAND}`}</title>
        <meta name="description" content={brandify('Wind Marketing builds production-grade marketing automation systems that eliminate manual workflows, integrate your data, and scale your operations without increasing overhead.')} />
        <meta name="keywords" content={`marketing automation agency, workflow automation, CRM automation, business process automation, ${BRAND} automation`} />
        <link rel="canonical" href="https://www.wind-marketing.com/automation" />
        <meta property="og:title" content={`Marketing Automation Services • ${BRAND}`} />
        <meta property="og:description" content={brandify('Wind Marketing builds production-grade marketing automation systems that eliminate manual workflows and scale your operations.')} />
        <meta property="og:url" content="https://www.wind-marketing.com/automation" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Marketing Automation",
            "provider": {
              "@type": "Organization",
              "name": "${BRAND}",
              "url": "https://www.wind-marketing.com"
            },
            "description": "${brandify('Production-grade marketing automation and workflow systems for growth-stage businesses. Wind Marketing eliminates manual processes, integrates data sources, and builds scalable automation pipelines that free your team and grow revenue.')}",
            "url": "https://www.wind-marketing.com/automation",
            "serviceType": "Marketing Automation",
            "areaServed": "Worldwide"
          }
        `}</script>
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What types of automation does ${BRAND} build?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "${brandify('Wind Marketing builds custom automation workflows including lead nurturing sequences, CRM integrations, data pipeline automation (e.g., Google Sheets to email), custom-triggered event configurations, and scalable multi-process automation systems for growing businesses.')}"
                }
              },
              {
                "@type": "Question",
                "name": "How much does marketing automation cost with ${BRAND}?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "${brandify("Wind Marketing's Automation plan starts at $149/month with a $499 setup fee, covering one automated process and one data integration. The Automation Pro plan at $249/month supports up to 5 automated processes, multiple data integrations, and includes custom error monitoring.")}"
                }
              }
            ]
          }
        `}</script>
      </Helmet>
      {/* Main Content Area */}
      <div className="max-w-4xl mx-auto mt-12 mb-20 flex-grow w-full">
        {/* Breadcrumb / Back button */}


        {/* Header Section */}
        <div className="w-full mb-27">
          <h1 
            className="text-4.5xl whitespace-nowrap sm:text-6xl md:text-8xl lg:text-9xl font-bold uppercase tracking-tighter leading-none mb-8 text-foreground"
            style={{ fontFamily: "'Poppins Black', sans-serif" }}
          >
            AUTOMATION
          </h1>
          
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-medium">
            Time is your most valuable asset, and manual workflows are the friction that slows your business growth down. Automation is the secret weapon that frees your team from repetitive tasks and lets you scale operations without increasing overhead.
          </p>
        </div>

        <ServiceShowcase currentPath="/automation" navigate={navigate} />

        {/* Interactive Buttons */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-12">
          <Button 
            size="large"
            onClick={() => navigate('/contact', { serviceInterest: 'automation' })}
          >
            Build Your Automation System
          </Button>
          <Button 
            variant="outline" 
            size="large"
            onClick={() => navigate('/work')}
          >
            OUR SERVICES
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AutomationPage;
